/**
 * The seam's stub marker, shared by every v3 package: a stub dies with
 * {@link V3NotImplemented} (a defect, not a typed failure), so the interfaces' error
 * channels stay exactly what the real implementations fail with.
 *
 * @since 1.0.0
 */
import { Data, Effect, Stream } from "effect";

/**
 * A seam stub was called. Its ticket has not landed.
 *
 * @since 1.0.0
 */
export class V3NotImplemented extends Data.TaggedError("V3NotImplemented")<{
  readonly service: string;
  readonly method: string;
}> {}

/**
 * Die with {@link V3NotImplemented}. Typed `never` so a stub fits any method signature.
 *
 * @since 1.0.0
 */
export const notImplemented = (service: string, method: string): Effect.Effect<never> =>
  Effect.die(new V3NotImplemented({ service, method }));

/**
 * The stream form of {@link notImplemented}.
 *
 * @since 1.0.0
 */
export const notImplementedStream = (service: string, method: string): Stream.Stream<never> =>
  Stream.die(new V3NotImplemented({ service, method }));
